// import { getCssColor } from 'shared/libs/getCssColor'

export const palette = {
  // primary: getCssColor('--app-primary'),
  primary: '#0092A1',
  light_gray_1: '#EAEEF0',
  light_gray_3: '#E0E5E8',
  dark: '#0E0F11',
  dark_2: '#262842',
  dark_3: '#162327',
  dark_4: '#1F2937',
  dark_5: '#033A29',
  dark_6: '#17191D',
  light_gray_2: '#f4f6f7',
  light_gray_4: '#768793',
  light_gray_5: '#DBDEE3',
  light_gray_6: '#CAD1D7',
  light_gray_7: '#D7DCE1',
  light_gray_8: '#8B8C9E',
  light_gray_9: '#939EAA',
  light_gray_10: '#A9B4BC',
  light_gray_11: '#7A8A96',
  light_gray_12: '#465564',
  light_gray_13: '#E0E3EA',
  light_gray_14: '#EFF0F1',
  light_gray_15: '#A9A9B8',
  light_gray_16: '#5D6C79',
  light_gray_17: '#878788',
  light_gray_18: '#F0F3F4',
  light_gray_19: '#818284',
  light_gray_20: '#F6F6F7',
  snow_gray: '#F7F8FC',
  gray: '#40474F',
  dark_gray_1: '#3E454C',
  dark_gray_2: '#6D6E85',
  light_blue_1: '#DBEAFE',
  blue: '#3B82F6',
  dark_blue_1: '#2563EB',
  dark_blue_2: '#3781CB',
  dark_blue_3: '#007994',
  light_blue_2: '#EAF0FD',
  light_blue_3: '#C2E2FF',
  light_blue_4: '#eff6ff',
  white: '#FFF',
  red: '#E11D48',
  red_2: '#EF4444',
  red_3: '#ff4d4f',
  red_4: '#f11',
  red_5: '#E94E3A',
  pink: '#8B5CF6',
  pink_2: '#7C3AED',
  yellow: '#FDDB2B',
  light_yellow_1: '#FEF3B5',
  orange: '#FFA530',
  orange_2: '#EA580C',
  dark_orange_1: '#F97316',
  green: '#10B981',
  light_green_1: '#E7F8F2',
  light_green_2: '#C6F1DD',
  light_green_3: '#C8F2E9',
  light_green_4: '#D3F8E9',
  light_green_5: '#E6F8F1',
  dark_green_1: '#2DB77B',
  dark_green_2: '#009C4D',
  dark_green_3: '#0DA257',
  dark_green_4: '#0FA976',
  beige: '#F9F2DA',
  light_red_1: '#FCA5A5',
  light_red_2: '#FFE0E0',
  brown: '#713F12',
}
